module.exports={render:function (){
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Danh sách đơn đối soát",
      "breadcrumbs": [{
        title: 'Quản lý đối soát',
        route: {
          name: 'compare'
        }
      }]
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-download"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("Xuất excel")])], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('gs-table', {
    ref: _vm.compareTable,
    attrs: {
      "table-name": _vm.compareTable,
      "data-source": "compares",
      "data-params": _vm.filters,
      "data-sorted": _vm.sorted,
      "data-sorts": _vm.sorts
    },
    on: {
      "remove-filter": _vm.removeFilter
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(datas) {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.compareTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) +
                ((_vm.dataPaginations[_vm.compareTable].current_page - 1) * _vm.dataPaginations[_vm.compareTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Đối Soát",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shipment) ? _c('p', {
                class: _vm.shipmentStatuses[scope.row.shipment.data.status]
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Trạng thái vận đơn"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-file-text-o",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.shipment.data.status_txt) + "\n                    "), (scope.row.shipment.data.is_return) ? _c('small', [_vm._v("(Chuyển hoàn)")]) : _vm._e(), (scope.row.shipment.data.is_part_delivery) ? _c('small', [_vm._v("(Giao một phần)")]) : _vm._e(), (scope.row.shipment.data.is_lost) ? _c('small', [_vm._v("(Thất lạc)")]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), _c('p', {
                class: _vm.listtingComparesStatus[scope.row.status]
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Trạng thái"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-info-circle",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.status_txt))])])], 1), _vm._v(" "), _c('p', {
                staticClass: "text-red"
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Trạng thái lỗi"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-exclamation-circle",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.error_txt))])])], 1), _vm._v(" "), _c('p', [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Ngày tạo"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-clock-o",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.created_at))])])], 1)]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shipment) ? _c('p', [_c('span', [_vm._v("Mã vận đơn: ")]), (scope.row.shipment) ? _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.shipment.data.id))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', [_c('span', [_vm._v("Mã đơn HVC: ")]), _vm._v(" "), _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.shipment.data.code))])]) : _vm._e(), _vm._v(" "), (scope.row.cross_check) ? _c('p', [_c('span', [_vm._v("Mã lịch sử đối soát: ")]), _vm._v(" "), _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.cross_check.data.id))])]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', [_c('span', [_vm._v("Mã phiếu chi cod: ")]), _vm._v(" "), _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.shipment.data.invoice.data.id))])]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', [_c('span', [_vm._v("Mã phiếu chi phí: ")]), _vm._v(" "), _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.shipment.data.invoice_fee.data.id))])]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin Khách Hàng"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shipment && scope.row.client) ? _c('p', [_c('i', {
                staticClass: "fa fa-user"
              }), _vm._v(" " + _vm._s(scope.row.client.data.name))]) : _vm._e(), _vm._v(" "), (scope.row.shipment && scope.row.client) ? _c('p', [_c('i', {
                staticClass: "fa fa-mobile"
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.client.data.phone))])]) : _vm._e(), _vm._v(" "), (scope.row.shipment && scope.row.client) ? _c('p', [_c('i', {
                staticClass: "fa fa-envelope-o",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.client.data.email))])]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("Tiền thu hộ (COD)")]), _vm._v(" "), _c('p', [_vm._v("Tổng phí")]), _vm._v(" "), _c('p', [_vm._v("Khuyến mãi")]), _vm._v(" "), _c('p', [_vm._v("Cân nặng")]), _vm._v(" "), _c('p', [_vm._v("Cân quy đổi")]), _vm._v(" "), _c('p', [_vm._v("Tạm thu")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin Đối Soát"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', {
                staticClass: "text-red"
              }, [_c('p', {
                staticClass: "text-right click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.cod_amount)))]), _vm._v(" "), _c('p', {
                staticClass: "text-right click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_fee)))]), _vm._v(" "), _c('p', {
                staticClass: "text-right click-copy"
              }, [_vm._v("0 đ")])]), _vm._v(" "), _c('p', {
                staticClass: "text-right click-copy"
              }, [_vm._v(_vm._s(_vm._f("gam")(scope.row.weight)))]), _vm._v(" "), _c('p', {
                staticClass: "text-right click-copy"
              }, [_vm._v(_vm._s(_vm._f("gam")(scope.row.convertion_weight)))]), _vm._v(" "), _c('p', {
                staticClass: "text-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("gam")(scope.row.payed_fee)))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin Vận Đơn"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', {
                staticClass: "text-red"
              }, [(scope.row.shipment) ? _c('p', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.shipment.data.amount_for_cross)) + "\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.shipment.data.total_fee)))]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.shipment.data.discount)))]) : _vm._e()]), _vm._v(" "), (scope.row.parcel) ? _c('p', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(_vm._f("gam")(scope.row.parcel.data.weight)))]) : _vm._e(), _vm._v(" "), (scope.row.parcel) ? _c('p', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.parcel.data.convertion_weight)))]) : _vm._e(), _vm._v(" "), _c('p', {
                staticClass: "text-right click-copy"
              }, [_vm._v(" ")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông tin tài chính"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', {
                staticClass: "text-red"
              }, [(scope.row.shipment) ? _c('p', [_vm._v("Revenue: "), _c('span', {
                staticClass: "pull-right click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.shipment.data.total_fee)))])]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', [_vm._v("Cost: "), _c('span', {
                staticClass: "pull-right click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_fee)))])]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', [_vm._v("Profit: "), _c('span', {
                staticClass: "pull-right click-copy"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.shipment.data.total_fee - scope.row.total_fee)))])]) : _vm._e()])]
            }
          }], null, true)
        })], 1)]
      }
    }])
  }, [_c('section', {
    staticStyle: {
      "margin-bottom": "24px"
    },
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    staticClass: "width-100",
    attrs: {
      "size": "small",
      "type": "daterange",
      "range-separator": " / ",
      "format": "dd-MM-yyyy",
      "start-placeholder": "Từ ngày",
      "end-placeholder": "Đến ngày"
    },
    on: {
      "input": _vm.updateFilters
    },
    model: {
      value: (_vm.filterDateRange),
      callback: function($$v) {
        _vm.filterDateRange = $$v
      },
      expression: "filterDateRange"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [(_vm.compareHelpers.statuses) ? _c('el-radio-group', {
    staticClass: "status-listting",
    attrs: {
      "fill": _vm.listtingComparesStatusBg[_vm.filters.status]
    },
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.status),
      callback: function($$v) {
        _vm.$set(_vm.filters, "status", $$v)
      },
      expression: "filters.status"
    }
  }, [_vm._l((_vm.compareHelpers.statuses), function(status, index) {
    var _obj;

    return _c('el-radio-button', {
      key: index,
      attrs: {
        "label": index
      }
    }, [_c('el-tooltip', {
      staticClass: "display-inline",
      attrs: {
        "placement": "top",
        "content": "Trạng thái"
      }
    }, [_c('span', {
      class: ( _obj = {}, _obj[_vm.listtingComparesStatus[index]] = _vm.filters.status != index, _obj )
    }, [_vm._v(_vm._s(status))])])], 1)
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": -1
    }
  }, [_c('el-tooltip', {
    staticClass: "display-inline",
    attrs: {
      "placement": "top",
      "content": "Trạng thái"
    }
  }, [_c('span', {
    class: ( _obj = {}, _obj[_vm.listtingComparesStatus[-1]] = _vm.filters.status != -1, _obj )
  }, [_vm._v("Tất cả")])])], 1)], 2) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.compareHelpers.errors) ? _c('el-radio-group', {
    staticClass: "status-listting",
    attrs: {
      "fill": _vm.listtingComparesErrorBg[_vm.filters.error_id]
    },
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.error_id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "error_id", $$v)
      },
      expression: "filters.error_id"
    }
  }, [_vm._l((_vm.compareHelpers.errors), function(error, index) {
    var _obj;

    return _c('el-radio-button', {
      key: index,
      attrs: {
        "label": index
      }
    }, [_c('el-tooltip', {
      staticClass: "display-inline",
      attrs: {
        "placement": "top",
        "content": "Vận đơn lỗi"
      }
    }, [_c('span', {
      class: ( _obj = {}, _obj[_vm.listtingComparesError[index]] = _vm.filters.error_id != index, _obj )
    }, [_vm._v(_vm._s(error))])])], 1)
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": -1
    }
  }, [_c('el-tooltip', {
    staticClass: "display-inline",
    attrs: {
      "placement": "top",
      "content": "Vận đơn lỗi"
    }
  }, [_c('span', {
    class: ( _obj$1 = {}, _obj$1[_vm.listtingComparesError[-1]] = _vm.filters.error_id != -1, _obj$1 )
  }, [_vm._v("Tất cả")])])], 1)], 2) : _vm._e()], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d172048"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/compare/ListtingAllCompare.vue
// module id = 656
// module chunks = 1